import * as React from "react";
import ProfileSkills from "./ProfileSkills";

interface Profile {
  skills: Array<any>;
  position_types: Array<any>;
  [prop: string]: any;
}

interface ProfileTagProps {
  profile: Profile;
  showPositionTypes?: boolean;
}

export default function ProfileTags({ profile, showPositionTypes = true }: ProfileTagProps) {
  return (
    <>
      {profile.skills &&
        profile.position_types &&
        (profile.skills.length > 0 || profile.position_types.length > 0) && (
          <ProfileSkills
            profile={profile}
            skills={profile.skills}
            showPositionTypes={showPositionTypes}
          />
        )}
    </>
  );
}
